import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";
import { computeV } from "../../../../helpers/SchemaComputeFunction";

export const VolumeSchema: ISchema = {
    displayName: "Volume",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'vNumber',
            displayName: 'V Number',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'width',
            displayName: 'Width (cm)',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12 medium-4",
        } as ISchemaProperty,    
        {
            name: 'height',
            displayName: 'Height (cm)',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12 medium-4",
        } as ISchemaProperty,     
        {
            name: 'depth',
            displayName: 'Depth (cm)',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12 medium-4",
        } as ISchemaProperty,
        {
            name: 'description',
            displayName: 'Description',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'computedVSize',
            displayName: 'Computed V size',
            type: PropertyTypes.computed,
            group: 1,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            className: "small-12 medium-3",
            computeFunction: ((x : number[]) => computeV([...x])) as Function,
            computeProperties: ["width", "height", "depth"]
        } as ISchemaProperty,
    ],
}
